export const InfiniteSlider = {
    init(selector = '.glide-clients') {
        window.addEventListener('load', () => {
            const sliders = document.querySelectorAll(selector);

            sliders.forEach(slider => {
                const list = slider.querySelector('.glide__slides');
                if (!list) return;

                const originalSlides = Array.from(list.children);

                // 1. Ensure we have enough logos to cover screen width
                let contentWidth = list.scrollWidth;
                while (contentWidth < window.innerWidth) {
                    originalSlides.forEach(slide => {
                        const clone = slide.cloneNode(true);
                        clone.classList.add('is-clone');
                        clone.setAttribute('aria-hidden', 'true');
                        list.appendChild(clone);
                    });
                    contentWidth = list.scrollWidth; // Recalculate width
                }

                // 2. Create a second "identical set" for the infinite effect
                const currentSlides = Array.from(list.children);
                currentSlides.forEach(slide => {
                    const clone = slide.cloneNode(true);
                    clone.classList.add('is-clone-set-2');
                    clone.setAttribute('aria-hidden', 'true');
                    list.appendChild(clone);
                });

                // Add class to show slider
                slider.classList.add('is-loaded');
            });
        });
    }
};
